import Vue from 'vue'
import { VueAutonumeric } from 'vue-autonumeric/src'

/* eslint-disable */
Vue.component('v-autonumeric', VueAutonumeric)
